import React from "react";
import { Navbar } from "reactstrap";
import { Link } from "react-router-dom";
import Logo from "../../atoms/logo";

const GuestHeader = () => {
  return (
    <>
      <Navbar
        color="white"
        light
        expand="md"
        className="box-shadow-bottom sticky-top"
      >
        <Link to="/" className="mx-auto navbar-brand">
          <Logo />
        </Link>
      </Navbar>
    </>
  );
};

export default GuestHeader;
